import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";

const KEY = "cookie-consent";
export const openCookieSettings = () => window.dispatchEvent(new Event("cookie-settings"));

export function CookieConsent() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => !localStorage.getItem(KEY));
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("cookie-settings", show);
    return () => window.removeEventListener("cookie-settings", show);
  }, []);
  // Never cover the officer console / portal controls; the notice lives on the public site.
  if (!open || pathname.startsWith("/admin") || pathname.startsWith("/portal")) return null;
  const accept = () => { localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); setOpen(false); };
  return (
    <div role="dialog" aria-label="Cookie notice" className="fixed inset-x-3 bottom-3 z-[70] rounded-2xl border border-gold/40 bg-slate-950/95 p-3 text-parchment shadow-2xl backdrop-blur animate-in fade-in slide-in-from-bottom-4 sm:inset-x-auto sm:right-3 sm:max-w-sm sm:p-4" data-testid="cookie-consent">
      <div className="flex items-center gap-3">
        <Cookie size={20} className="hidden shrink-0 text-gold sm:block" />
        <p className="flex-1 text-xs text-parchment/85">
          Only <b className="text-parchment">strictly necessary cookies</b> — no ads or tracking.{" "}
          <Link to="/cookies" className="underline text-gold hover:text-gold/80" data-testid="cookie-learn-more">Learn more</Link>
        </p>
        <Button size="sm" onClick={accept} className="h-9 shrink-0 bg-gold px-4 text-slate-950 hover:bg-gold/90" data-testid="cookie-accept">Got it</Button>
      </div>
    </div>
  );
}
